import { axiosInstanceWithToken } from 'utils/axios';

export const fetchCountries = async () => axiosInstanceWithToken().get<{ name: string; iso2: string }[]>('countries');
